
<div class="dashboard" *ngIf="!allowInsight">
    You don't have the permission to view insights
</div>
<div class="dashboard" *ngIf="allowInsight">
  <div class="dashboard-header">
    <div class="header-content">
      <div>
        <h2>Analytics Insights</h2>
        <p>Real-time performance metrics and conversation auditing</p>
      </div>

      <div class="filters" style="background: white; padding: 10px; border-radius: 12px; box-shadow: 0 2px 10px rgba(0,0,0,0.05);">
        <mat-form-field appearance="outline">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="sP" [(ngModel)]="startDate">
          <mat-datepicker-toggle matSuffix [for]="sP"></mat-datepicker-toggle>
          <mat-datepicker #sP></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="eP" [(ngModel)]="endDate">
          <mat-datepicker-toggle matSuffix [for]="eP"></mat-datepicker-toggle>
          <mat-datepicker #eP></mat-datepicker>
        </mat-form-field>
        
        </div>
    </div>
  </div>

  <mat-tab-group class="analytics-tabs" dynamicHeight color="primary">
    
    <mat-tab label="Executive Summary">
      <div style="padding: 20px 0;">
        <app-outcome-rate [globalStartDate]="startDate" [globalEndDate]="endDate"></app-outcome-rate>
        
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(450px, 1fr)); gap: 20px; margin-top: 20px;">
          <app-category-distribution [globalStartDate]="startDate" [globalEndDate]="endDate"></app-category-distribution>
          <app-outcome-distribution [globalStartDate]="startDate" [globalEndDate]="endDate"></app-outcome-distribution>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Engagement Analysis">
      <div style="padding: 20px 0;">
        <app-engagement-frequency [globalStartDate]="startDate" [globalEndDate]="endDate"></app-engagement-frequency>
        <div style="margin-top: 20px;">
          <app-cross-tab [globalStartDate]="startDate" [globalEndDate]="endDate"></app-cross-tab>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Conversation Explorer">
      <div style="padding: 20px 0;">
        <app-conversation-explorer [globalStartDate]="startDate" [globalEndDate]="endDate"></app-conversation-explorer>
      </div>
    </mat-tab>

    <mat-tab label="Raw Data Explorer">
        <div style="padding-top: 2rem;">
            <app-data-table 
            [globalStartDate]="startDate" 
            [globalEndDate]="endDate">
            </app-data-table>
        </div>
    </mat-tab>

  </mat-tab-group>
</div>